import type { RuleSource } from './types'

export const RULE_SOURCES: RuleSource[] = [
  {
    id: 'lsu-carpetgrass-2026',
    title: 'Louisiana Home Lawn Series: Carpetgrass',
    institution: 'LSU AgCenter',
    url: 'https://www.lsuagcenter.com/profiles/aiverson/articles/page1551975010823',
    accessedAt: '2026-09-23',
    appliesTo: ['mowing_height', 'nitrogen', 'watering', 'aeration'],
  },
  {
    id: 'okstate-shade-2026',
    title: 'Managing Turfgrass in the Shade in Oklahoma',
    institution: 'Oklahoma State University Extension',
    url: 'https://extension.okstate.edu/fact-sheets/managing-turfgrass-in-the-shade-in-oklahoma',
    accessedAt: '2026-06-06',
    appliesTo: ['sunlight', 'shade_tolerance', 'mowing_height', 'nitrogen', 'watering'],
  },
  {
    id: 'uf-ifas-shade-2026',
    title: 'Growing Turfgrass in the Shade',
    institution: 'University of Florida IFAS Extension',
    url: 'https://ask.ifas.ufl.edu/publication/EP072/pdf',
    accessedAt: '2026-06-06',
    appliesTo: ['sunlight', 'shade_tolerance', 'mowing_height', 'fertilizer', 'watering', 'disease'],
  },
  {
    id: 'missouri-shade-2026',
    title: 'Grasses in Shade: Establishing and Maintaining Lawns in Low Light',
    institution: 'University of Missouri Extension',
    url: 'https://extension.missouri.edu/publications/g6725',
    accessedAt: '2026-06-06',
    appliesTo: ['sunlight', 'shade_tolerance', 'nitrogen', 'mowing_height', 'watering'],
  },
  {
    id: 'umd-established-lawn-2026',
    title: 'Maintaining an Established Lawn',
    institution: 'University of Maryland Extension',
    url: 'https://extension.umd.edu/resource/maintaining-established-lawn',
    accessedAt: '2026-06-06',
    appliesTo: ['mowing_height', 'one_third_rule', 'watering'],
  },
  {
    id: 'purdue-fertilizer-2026',
    title: 'Fertilizer Recommendations',
    institution: 'Purdue University Turfgrass Science',
    url: 'https://turf.purdue.edu/fertilizer-recommendations/',
    accessedAt: '2026-06-06',
    appliesTo: ['nitrogen', 'fertilizer_timing', 'shade', 'species_adjustment'],
  },
  {
    id: 'rutgers-fertilizer-math-2026',
    title: 'How to Calculate the Amount of Fertilizer Needed for Your Lawn',
    institution: 'Rutgers NJAES',
    url: 'https://njaes.rutgers.edu/FS839/',
    accessedAt: '2026-06-06',
    appliesTo: ['lawn_size', 'fertilizer_quantity', 'nitrogen_math', 'water_quantity'],
  },
  // Promoted from data/authority-citations.ts (URLs verified 2026-06-12) into
  // typed RuleSources with GRANULAR topic keys so the seasonal-rules + quantity
  // coverage tests can topic-match each claim to a source.
  {
    id: 'purdue-preemergent-2026',
    title: 'Turfgrass Weed Control',
    institution: 'Purdue Turfgrass Science',
    url: 'https://turf.purdue.edu/',
    accessedAt: '2026-06-12',
    appliesTo: ['pre_emergent_timing', 'soil_temperature', 'crabgrass_gdd', 'weed_control'],
  },
  {
    id: 'msu-seeding-gdd-2026',
    title: 'Seeding, Crabgrass Timing, and Growing Degree Days',
    institution: 'Michigan State University Turf',
    url: 'https://www.canr.msu.edu/turf/',
    accessedAt: '2026-06-12',
    appliesTo: ['seeding_rate', 'seeding_soil_temp', 'crabgrass_gdd', 'gdd_base_temp', 'gdd_target', 'aeration_timing'],
  },
  {
    id: 'pennstate-lawn-care-2026',
    title: 'Turfgrass and Lawn Care',
    institution: 'Penn State Extension',
    url: 'https://extension.psu.edu/trees-lawns-and-landscaping/turfgrass-and-lawn-care',
    accessedAt: '2026-06-12',
    appliesTo: ['nitrogen', 'fertilizer_timing', 'overseeding', 'aeration_timing', 'mowing_height', 'seasonal_window'],
  },
  {
    id: 'ncstate-disease-2026',
    title: 'TurfFiles: Disease and Irrigation Timing',
    institution: 'NC State TurfFiles',
    url: 'https://www.turffiles.ncsu.edu/',
    accessedAt: '2026-06-12',
    appliesTo: ['disease_risk', 'watering', 'weed_control'],
  },
  {
    id: 'tamu-watering-2026',
    title: 'AggieTurf: Watering Guidance',
    institution: 'Texas A&M AggieTurf',
    url: 'https://aggieturf.tamu.edu/',
    accessedAt: '2026-06-12',
    appliesTo: ['watering', 'water_quantity'],
  },
  {
    id: 'osu-grubs-2026',
    title: 'Buckeye Turf: White Grub Thresholds',
    institution: 'Ohio State Buckeye Turf',
    url: 'https://buckeyeturf.osu.edu/',
    accessedAt: '2026-06-12',
    appliesTo: ['grub_threshold', 'disease_risk'],
  },
]

export function ruleSourcesFor(ids: string[]): RuleSource[] {
  const wanted = new Set(ids)
  return RULE_SOURCES.filter((source) => wanted.has(source.id))
}
